import { useEffect, useState } from 'react';
import type { OwapWebviewType } from '@/utils/owap';
import { getOwapWebviewType, isOwapApp } from '@/utils/owap';

interface UseOwapInfoReturns {
  isOwap: boolean;
  owapWebviewType: OwapWebviewType | null;
}

export const useOwapInfo = (): UseOwapInfoReturns => {
  const [isOwap, setIsOwapApp] = useState(false);
  const [owapWebviewType, setOwapWebviewType] =
    useState<OwapWebviewType | null>(null);

  useEffect(() => {
    setIsOwapApp(isOwapApp());
    setOwapWebviewType(getOwapWebviewType());
  }, []);

  return {
    isOwap,
    owapWebviewType,
  };
};
